import { render, staticRenderFns } from "./AllergensAi.vue?vue&type=template&id=30180b5c&scoped=true"
import script from "./AllergensAi.vue?vue&type=script&lang=ts"
export * from "./AllergensAi.vue?vue&type=script&lang=ts"
import style0 from "./AllergensAi.vue?vue&type=style&index=0&id=30180b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30180b5c",
  null
  
)

export default component.exports